module.exports = __webpack_public_path__ + "img/bvd.1630993415105.png";